import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

type PortalComponentProps = {
  children: ReactNode;
  container?: HTMLElement;
};

export const PortalComponent = ({
  children,
  container = document.body,
}: PortalComponentProps) => {
  return createPortal(children, container);
};
